export default __webpack_public_path__ + "static/media/0f2063043cdcb652099d5ac95cef9051.svg";